/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CheckUsage, JobSpecTemplateRestService } from '@gh/builder-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { ComponentListCheckUsage } from '../../estimating/resources/component-list-item.model';
import { JobSpecTemplateFilter, JobSpecTemplateListItem } from './job-spec-template.model';

@Injectable()
export class JobSpecTemplateListTabBusinessService {
  constructor(private jobSpecTemplateRest: JobSpecTemplateRestService,
              private gridLayoutService: GridLayoutService) {
  }

  findAllAsDataSource(filter: JobSpecTemplateFilter): SlicedDataSource<JobSpecTemplateListItem> {
    return this.jobSpecTemplateRest.findAllAsDataSource(filter);
  }

  activate(component: JobSpecTemplateListItem): Observable<JobSpecTemplateListItem> {
    return this.jobSpecTemplateRest.undelete(component);
  }

  checkUsage(component: JobSpecTemplateListItem): Observable<CheckUsage> {
    return this.jobSpecTemplateRest.checkUsage(component);
  }

  deactivateOrDelete(component: JobSpecTemplateListItem, checkUsage: ComponentListCheckUsage): Observable<any> {
    return this.jobSpecTemplateRest.deactivateOrDelete(component, checkUsage);
  }
}
